import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, unref as _unref, createVNode as _createVNode, createCommentVNode as _createCommentVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b591edde"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-flex tw-justify-center tw-gap-[10px]" }
const _hoisted_2 = { class: "" }
const _hoisted_3 = { class: "tw-flex tw-justify-center tw-gap-[10px]" }
const _hoisted_4 = { class: "" }
const _hoisted_5 = { class: "tw-flex tw-items-center tw-justify-center" }

import { getComponentUiText } from "@/utils/utilities";
import CustomTable, {
  CustomTableColumn,
} from "@/components/common/customTable.vue";
import { computed } from "vue";
import QualityAssessment from "./qualityAssessment.vue";
import AssessmentChecklistStatusTag from "@/components/assessment/assessmentChecklistStatusTag.vue";
import { CHECKLISTSTATUS, QUALITY_ASSESSMENT_TYPE } from "@/utils/constants";
import TextAreaRoadmap from "./textAreaRoadmap.vue";
export type roadmapTableColumn = {
  id: any;
  checklistGroupOrder: number;
  checklistGroupIsQuickWin: boolean;
  checklistGroupName: string;
  checklistGroupDescription: string;
  checklistGroupActions: string | null;
  checklistGroupBang: string;
  checklistGroupBuck: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'roadmapTable',
  props: {
  data: {
    type: Array as () => roadmapTableColumn[],
    required: true,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    required: false,
  },
  columns: {
    type: Array,
    required: false,
    default: () => ["order", "doWhat", "how", "impact", "effort", "status"],
  },
  isEditStatus: {
    type: Boolean,
    required: false,
    default: false,
  },
},
  emits: ["edit-notes"],
  setup(__props, { emit }) {

const props = __props;





const columnsTableFields = computed<CustomTableColumn[]>(() => {
  return [
    {
      text: getComponentUiText(
        "app-share-cyber-profile-roadmap-table-order-header-title-1",
      ),
      value: "order",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase tw-w-[10%]",
      valueClass:
        "tw-text-[#231F20] tw-text-[13px] tw-font-medium tw-w-[10%] tw-h-[70px]",
      sortable: false,
      sortDefault: false,
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-roadmap-table-do-what-header-title-1",
      ),
      value: "doWhat",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase tw-w-[25%]",
      valueClass: `tw-text-[#231F20] tw-text-[13px] tw-font-normal tw-w-[25%] tw-items-center ${
        props.isEditStatus ? "!tw-pr-[10px] !tw-py-[12.5px]" : ""
      }`,
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-roadmap-table-how-header-title-1",
      ),
      value: "how",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] !tw-py-[unset] tw-leading-[100%] tw-uppercase  tw-w-[30%]",
      valueClass: `tw-text-[#231F20] tw-text-[13px] tw-font-normal  tw-w-[30%] tw-items-center ${
        props.isEditStatus ? "!tw-pr-[10px] !tw-py-[12.5px]" : ""
      }`,
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-roadmap-table-importance-header-title-1",
      ),
      value: "impact",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal",
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-roadmap-table-cost-header-title-1",
      ),
      value: "effort",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase ",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal",
    },
    {
      text: getComponentUiText(
        "app-share-cyber-profile-roadmap-table-status-header-title-1",
      ),
      value: "status",
      headerClass:
        "!tw-text-[#ffffff] tw-text-[10px] tw-font-semibold tw-tracking-[1px] tw-leading-[100%] tw-uppercase",
      valueClass: "tw-text-[#231F20] tw-text-[13px] tw-font-normal",
    },
  ].filter((item) => props.columns.includes(item.value));
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomTable, {
    columns: columnsTableFields.value,
    data: __props.data,
    "is-loading": __props.isLoading,
    "show-checkbox-row": false,
    "sort-direction": 'asc',
    "skeleton-row-number": 1,
    "custom-class": '!tw-shadow-none road-map-table',
    "header-wrapper-class": 'tw-py-[20px] tw-px-[25px] tw-h-[56px]'
  }, {
    "cell(order)": _withCtx((value) => [
      _createElementVNode("span", {
        class: _normalizeClass(["tw-text-[13px] tw-text-[#231F20] tw-font-medium tw-whitespace-nowrap", 
          value.item.checklistGroupCompletionPcnt === 1
            ? 'tw-text-[#B7B7B7]'
            : ''
        ])
      }, _toDisplayString(value.item.index), 3)
    ]),
    "cell(doWhat)": _withCtx((value) => [
      (_openBlock(), _createBlock(TextAreaRoadmap, {
        key: `roadmap-do-what-${value.item.checklistGroupId}`,
        "is-edit-status": __props.isEditStatus,
        item: value.item,
        "key-field": 'checklistGroupName',
        "custom-class": 
          value.item.checklistGroupCompletionPcnt === 1
            ? 'tw-text-[#B7B7B7]'
            : ''
        ,
        onEditNotes: _cache[0] || (_cache[0] = ($event: any) => (emit('edit-notes')))
      }, null, 8, ["is-edit-status", "item", "custom-class"]))
    ]),
    "cell(how)": _withCtx((value) => [
      (_openBlock(), _createBlock(TextAreaRoadmap, {
        key: `roadmap-how-${value.item.checklistGroupId}`,
        "is-edit-status": __props.isEditStatus,
        item: value.item,
        "key-field": 'checklistGroupActions',
        "custom-class": 
          value.item.checklistGroupCompletionPcnt === 1
            ? 'tw-text-[#B7B7B7]'
            : ''
        ,
        onEditNotes: _cache[1] || (_cache[1] = ($event: any) => (emit('edit-notes')))
      }, null, 8, ["is-edit-status", "item", "custom-class"]))
    ]),
    "cell(impact)": _withCtx((value) => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", _hoisted_2, [
          _createVNode(QualityAssessment, {
            data: value.item.checklistGroupBang,
            "is-completed": value.item.checklistGroupCompletionPcnt === 1,
            type: _unref(QUALITY_ASSESSMENT_TYPE).IMPORTANCE
          }, null, 8, ["data", "is-completed", "type"])
        ])
      ])
    ]),
    "cell(effort)": _withCtx((value) => [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, [
          _createVNode(QualityAssessment, {
            data: value.item.checklistGroupBuck,
            "is-completed": value.item.checklistGroupCompletionPcnt === 1,
            type: _unref(QUALITY_ASSESSMENT_TYPE).COST
          }, null, 8, ["data", "is-completed", "type"])
        ])
      ])
    ]),
    "cell(status)": _withCtx((value) => [
      _createElementVNode("div", _hoisted_5, [
        (value.item.checklistGroupCompletionPcnt !== null)
          ? (_openBlock(), _createBlock(AssessmentChecklistStatusTag, {
              key: 0,
              "checklist-status": 
            value.item.checklistGroupCompletionPcnt === 1
              ? _unref(getComponentUiText)(
                  'app-component-assessments-checklists-assessment-details-card-status-3',
                )
              : value.item.checklistGroupCompletionPcnt > 0 &&
                  value.item.checklistGroupCompletionPcnt < 1
                ? _unref(getComponentUiText)(
                    'app-component-assessments-checklists-assessment-details-card-status-1',
                  )
                : _unref(getComponentUiText)(
                    'app-component-assessments-checklists-assessment-details-card-status-2',
                  )
          ,
              "checklist-status-id": 
            value.item.checklistGroupCompletionPcnt === 1
              ? _unref(CHECKLISTSTATUS).DONE
              : value.item.checklistGroupCompletionPcnt > 0 &&
                  value.item.checklistGroupCompletionPcnt < 1
                ? _unref(CHECKLISTSTATUS).INPROG
                : _unref(CHECKLISTSTATUS).NEW
          ,
              "is-loading": false
            }, null, 8, ["checklist-status", "checklist-status-id"]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["columns", "data", "is-loading"]))
}
}

})